<stages-dialog2 [backdropDisabled]="true" [classes]="['autoHeight', 'small-dialog']" #dialog>
	<stages-dialog-header>
		<h2 translate="user.settings.otp" class="limit-width"></h2>
	</stages-dialog-header>
	<div class="content otp-dialog limit-width">
		<div class="panel">
			<form [formGroup]="otpFormGroup" (stagesKeyUp)="onKeyUp($event)">
				<div class="form otp-form">
					<h4 [translate]="'user.otp.' + newType + '.heading'"></h4>
					<p [translate]="'user.otp.' + newType + '.description'"></p>
					<div class="input-container required" *ngIf="!showCodeInput()">
						<label class="input-label" for="password" translate="user.password"></label>
						<input
							class="text fullsize"
							type="password"
							id="password"
							name="password"
							autocomplete="off"
							formControlName="oldPassword"
							stagesAutofocus
						/>
						<div class="info">
							<div class="errors">
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('oldPassword', 'required')"
									role="alert"
									translate="input.required"
								></div>
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('oldPassword', 'incorrect')"
									role="alert"
									translate="user.password.incorrect"
								></div>
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('oldPassword', 'accountLocked')"
									role="alert"
									translate="login.error.accountLocked"
								></div>
							</div>
						</div>
					</div>
					<div class="input-container" *ngIf="showCodeInput()">
						<div *ngIf="getResultURL() as url">
							<label class="input-label" for="qr-code" translate="user.otp.TOTP.scan.heading"></label>
							<qrcode id="qr-code" [qrdata]="url" [width]="256" [margin]="0" [errorCorrectionLevel]="'M'"></qrcode>
							<p translate="user.otp.TOTP.scan.description"></p>
						</div>
					</div>
					<div class="input-container required" *ngIf="showCodeInput()">
						<label class="input-label" for="code" [translate]="'user.otp.' + newType + '.setup.confirm'"></label>
						<input
							#codeInput
							formControlName="code"
							type="text"
							id="code"
							name="code"
							class="text fullsize"
							required
							inputmode="numeric"
							pattern="[0-9]*"
							autocomplete="one-time-code"
							stagesAutofocus
						/>
						<div class="info">
							<div class="errors">
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('code', 'required')"
									role="alert"
									translate="input.required"
								></div>
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('code', 'incorrect')"
									role="alert"
									translate="login.error.code.verify.failed"
								></div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<footer>
			<stages-buttons-bottom [removeBoundaries]="true">
				<button type="action" class="button sm cancel" (click)="onCancel()" translate="cancel"></button>
				<button
					type="submit"
					class="button sm prime"
					(click)="onSave()"
					[disabled]="isInProgress() || otpFormGroup.invalid"
					[translate]="'user.otp.' + newType + '.switch'"
				></button>
			</stages-buttons-bottom>
		</footer>
	</div>
</stages-dialog2>
